module.exports = __webpack_public_path__ + "static/img/2.e6e8e36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.png
// module id = 20
// module chunks = 0